import { MeshType, MeshSubType, Side } from "./types";

export const ASSETS_URI = '/assets/jhaudio/3d/assets';
export const SCENE_URI = `${ASSETS_URI}/scenes`;
export const TEXTURES_URI = `${ASSETS_URI}/textures`;

export const MESHES: MeshType[] = ["iem", "cable"];
// NOTE: Don't include innerouter combo. As it is used internally to reuse textureSets between them
export const MESH_SUB_TYPES: MeshSubType[] = ["inner", "outer", "test"];
export const SIDES: Side[] = ['left', 'right'];
    
